
document.addEventListener('DOMContentLoaded', function() {
  initNav();
  initFAQ();
  initStickyHeader();
  initScrollProgress();
  initGallery();
  initProductTabs();initPlanSelector();
  initAnimations();
  loadCartCount();
    initWelcomePopup();
});

function initNav() {
  var toggle = document.getElementById('navToggle');
  var menu = document.getElementById('navMenu');
  if (!toggle || !menu) return;
  toggle.addEventListener('click', function() {
    menu.classList.toggle('active');
  });
}

function initFAQ() {
  document.querySelectorAll('.faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.parentElement;
      var isActive = item.classList.contains('active');
      document.querySelectorAll('.faq__item').forEach(function(i) { i.classList.remove('active'); });
      if (!isActive) item.classList.add('active');
    });
  });
}

function initStickyHeader() {
  var header = document.getElementById('header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    header.classList.toggle('header--scrolled', window.scrollY > 80);
  });
}

function initScrollProgress() {
  var bar = document.getElementById('scrollIndicator');
  if (!bar) return;
  window.addEventListener('scroll', function() {
    var pct = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
    bar.style.width = pct + '%';
  });
}

function initGallery() {
  var mainImg = document.getElementById('ProductMainImage');
  if (!mainImg) return;
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      mainImg.src = this.getAttribute('data-image');
      document.querySelectorAll('.product-gallery__thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });
}

function initProductTabs() {
  document.querySelectorAll('.product-tab').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tab = this.getAttribute('data-tab');
      document.querySelectorAll('.product-tab').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.product-tab-content').forEach(function(c) { c.classList.remove('active'); });
      this.classList.add('active');
      var content = document.getElementById('tab-' + tab);
      if (content) content.classList.add('active');
    });
  });
}

function initAnimations() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.benefit-card, .review-card, .order-card, .timeline__item, .ing-row').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });
}

function loadCartCount() {
  var count = localStorage.getItem('cerebra_cart') || '0';
  var el = document.getElementById('cartCount');
  if (el) el.textContent = count;
}

function updateCartCount(delta) {
  var count = parseInt(localStorage.getItem('cerebra_cart') || '0') + delta;
  localStorage.setItem('cerebra_cart', count);
  var el = document.getElementById('cartCount');
  if (el) el.textContent = count;
}


function initPlanSelector() {
var opts = document.querySelectorAll('.plan-option');
if (!opts.length) return;
opts.forEach(function(opt) {
opt.addEventListener('click', function() {
var price = this.getAttribute('data-price');
var badge = this.getAttribute('data-badge');
var qty = this.getAttribute('data-qty');
var plan = this.getAttribute('data-selling-plan');
if (price) {
var dp = document.getElementById('displayPrice');
var db = document.getElementById('displayBadge');
var bp = document.getElementById('btnPrice');
if (dp) dp.textContent = price;
if (db) db.textContent = badge || '';
if (bp) bp.textContent = price;
}
var qtyInput = document.querySelector('.qty-input');
if (qtyInput && qty) qtyInput.value = qty;
var planInput = document.querySelector('.selling-plan-input');
if (planInput) planInput.value = plan || '';
});
});
var checkedOpt = document.querySelector('.plan-option input[type="radio"]:checked');
if (checkedOpt) {
var checkedLabel = checkedOpt.closest('.plan-option');
if (checkedLabel) checkedLabel.click();
}
}

function initWelcomePopup() {
var popup = document.getElementById('welcomePopup');
if (!popup) return;
var dismissed = null;
try { dismissed = localStorage.getItem('cerebra_welcome_dismissed'); } catch (e) {}
if (dismissed) return;
function showPopup() {
popup.classList.add('welcome-popup--visible');
popup.setAttribute('aria-hidden', 'false');
}
function hidePopup() {
popup.classList.remove('welcome-popup--visible');
popup.setAttribute('aria-hidden', 'true');
try { localStorage.setItem('cerebra_welcome_dismissed', '1'); } catch (e) {}
}
window.setTimeout(showPopup, 7000);
var closeBtn = popup.querySelector('.welcome-popup__close');
if (closeBtn) closeBtn.addEventListener('click', hidePopup);
var overlay = popup.querySelector('.welcome-popup__overlay');
if (overlay) overlay.addEventListener('click', hidePopup);
var form = document.getElementById('welcomePopupForm');
if (form) {
form.addEventListener('submit', function(e) {
e.preventDefault();
var submitBtn = form.querySelector('.welcome-popup__submit');
submitBtn.textContent = 'Unlocking...';
submitBtn.disabled = true;
function actuallySubmit() {
    var formData = new FormData(form);
      fetch(form.action || '/contact', {
        method: 'POST',
          body: formData
            }).then(function(resp) {
              if (!resp.ok) { throw new Error('bad status'); }
                try { localStorage.setItem('cerebra_welcome_dismissed', '1'); } catch (e) {}
                  var formStep = popup.querySelector('.welcome-popup__step--form');
                    var successStep = popup.querySelector('.welcome-popup__step--success');
                      if (formStep) formStep.hidden = true;
                        if (successStep) successStep.hidden = false;
                          }).catch(function() {
                            submitBtn.textContent = 'Try Again';
                              submitBtn.disabled = false;
                                });
                                  }
                                    function waitForCaptchaAndSubmit(attempts) {
                                      attempts = attempts || 0;
                                        var captchaField = form.querySelector('[name="h-captcha-response"]');
                                          if (captchaField && captchaField.value) {
                                            actuallySubmit();
                                              } else if (attempts < 50) {
                                                window.setTimeout(function() { waitForCaptchaAndSubmit(attempts + 1); }, 200);
                                                  } else {
                                                    submitBtn.textContent = 'Try Again';
                                                      submitBtn.disabled = false;
                                                        }
                                                          }
                                                            if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
                                                              window.Shopify.captcha.protect(form, function() { waitForCaptchaAndSubmit(0); });
                                                                } else {
                                                                  actuallySubmit();
                                                                    }
});
}
var copyBtn = document.getElementById('welcomePopupCopy');
if (copyBtn) {
copyBtn.addEventListener('click', function() {
var codeEl = document.getElementById('welcomePopupCode');
var code = codeEl ? codeEl.textContent : '';
if (navigator.clipboard && code) {
navigator.clipboard.writeText(code).then(function() {
copyBtn.textContent = 'Copied!';
window.setTimeout(function() { copyBtn.textContent = 'Copy Code'; }, 2000);
});
}
});
}
}